site.godo = site.godo || {};
site.godo = $.extend({
	widget: function() {
		var $start = $('#checkin'),
			$finish = $('#checkout'),
			$submit = $('#godoSubmit');

		$start.datepicker({
			dateFormat: 'dd.mm.yy',
			minDate: 0
		});
		$finish.datepicker({
			dateFormat: 'dd.mm.yy',
			minDate: 1
		});

		$start.bind('change', function () {
			var startArr = $start.val().split('.');
			var start = startArr[2] + startArr[1] + startArr[0];
			var finishArr = $finish.val().split('.');
			var finish = finishArr[2] + finishArr[1] + finishArr[0];

			if ($finish.val() === '' || finish < start) {
				$finish.val($start.val());
			}
			var minDate = new Date(startArr[2], startArr[1] - 1, startArr[0]);
			minDate.setDate(minDate.getDate() + 1);
			$finish.datepicker("option", "minDate", minDate);
		});

		$submit.removeAttr('name');
	}
}, site.godo);
